import React, { Fragment, useState } from "react";
import connect from "react-redux/lib/connect/connect";
import { SetCurrentPage } from "../../common/actions/pageAction";
import {
  ClearSportsList,
  SetClicked,
  SetLeague,
  SetLocation,
  SetSearchType,
  SetSearchValue,
  SetSportId,
} from "../../common/actions/sportsAction";
import { convertNameKor, isEmpty, onErrorImg } from "../../common/cores";
import { resource_url } from "../../common/cores/keys";

const Locations = (props) => {
  const { list, type, sportId, Id, view } = props;
  const [active, setActive] = useState(false);
  const [clickedId, setClickedId] = useState("");
  const onLeague = (league) => {
    if (clickedId != league) {
      props.ClearSportsList();
      setClickedId(league);
    }
    props.SetSportId(sportId);
    props.SetLeague(league);
    props.SetLocation(Id);
    props.SetSearchType("");
    props.SetSearchValue("");
    props.SetClicked(true);
    props.SetCurrentPage({ page: 1, totalPage: 50 });
  };

  const onActive = () => {
    setActive(!active);
    if (type === "esports") {
      props.ClearSportsList();
      props.SetSportId(sportId);
      props.SetLeague(Id);
      props.SetLocation("all");
      props.SetCurrentPage({ page: 1, totalPage: 50 });
    }
  };
  return (
    <Fragment>
      <div className="country_frame" onClick={onActive}>
        <img
          src={
            isEmpty(list.image)
              ? props.imgPath
              : resource_url + "/images/locations/" + list.image
          }
          className="sports_country_img"
        />
        {convertNameKor(list)}
        <span className="sports_country_odd">
          ({Number(list.count).toLocaleString()})
        </span>
        <span className="sports_country_arrow">
          <i className="fa-solid fa-angle-down"></i>
        </span>
      </div>
      {!isEmpty(list.data) &&
        active &&
        list.data.map((item, index) => {
          return (
            <div
              className="country_frame01"
              key={index}
              onClick={() => {
                onLeague(item.id);
                view();
              }}
            >
              <div className="country">
                <span className="name">{convertNameKor(item)}</span>
                {Number(item.count).toLocaleString()}
              </div>
            </div>
          );
        })}
    </Fragment>
  );
};
const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  SetLeague,
  SetLocation,
  SetSportId,
  ClearSportsList,
  SetCurrentPage,
  SetSearchType,
  SetSearchValue,
  SetClicked,
})(Locations);



// WEBPACK FOOTER //
// ./src/components/sports/Locations.js